import type { SyntheticEvent } from 'react';
import { createElement, useEffect, useLayoutEffect, useState } from 'react';

import { Button, Dialog, RadioButton, Sheet, Typography } from '@sravni/react-design-system';
import type { SheetProps } from '@sravni/react-design-system/dist/types/components/Sheet';
import { useIsMobile } from '@sravni/react-utils';

import { sendOpenModalEbsBanner } from '@src/helpers/analyticsEvents';
import { isServer } from '@src/utils';

import { EbsBannerConfirmGuide } from './components/EbsBannerConfirmGuide/EbsBannerConfirmGuide';
import { EbsBannerDefaultGuide } from './components/EbsBannerDefaultGuide/EbsBannerDefaultGuide';
import { EBS_RADIO_OPTIONS } from './EbsDialogBanner.config';
import styles from './EbsDialogBanner.module.scss';
import { EbsDialogBannerTexts } from './EbsDialogBanner.texts';

const { Text } = Typography;

const TabsVariants = { 1: EbsBannerDefaultGuide, 2: EbsBannerConfirmGuide };

type Props = {
  visible: boolean;
  onClose: () => void;
} & SheetProps & { data: any; onOverlayClick(event: SyntheticEvent): void };

const LazyPixel = () => {
  useEffect(() => {
    if (isServer) {
      return;
    }
    sendOpenModalEbsBanner();
  }, []);

  return null;
};

export function EbsDialogBanner({ visible, onClose, data: _data, onOverlayClick: _onOverlayClick }: Props) {
  const isMobile = useIsMobile();

  const Component = isMobile ? Sheet : Dialog;

  const [screen, setScreenVariant] = useState<string | number>(1);

  return (
    <Component closable onClose={onClose} visible={visible} className={styles.root}>
      <LazyPixel />
      <Component.Header className={styles.heading} title={EbsDialogBannerTexts.heading} />
      <Component.Content className={styles.container}>
        <Text> {EbsDialogBannerTexts.description}</Text>
        <div className={styles.radioGroup}>
          <RadioButton
            defaultValue={screen}
            onChange={setScreenVariant}
            options={EBS_RADIO_OPTIONS}
            size={isMobile ? 44 : 36}
          />
        </div>

        {createElement(TabsVariants[screen], { isMobile })}
      </Component.Content>

      <div className={styles.footer}>
        <Button size={52} variant="primary" block onClick={onClose}>
          {EbsDialogBannerTexts.btnText}
        </Button>
      </div>
    </Component>
  );
}
